module.exports = __webpack_public_path__ + "img/68-l.5d513f79.png";